// Shared site content: navigation, FAQ, demo report, SEO cluster architecture.

export const SITE_URL = "https://okkioapp.com";
export const SITE_NAME = "OKKIO";
export const OFFICIAL_EMAIL = "info.okkioapp@gmail.com";
export const INDIE_TAGLINE = "Indipendente per davvero. Non vendiamo ristrutturazioni.";
export const CLIENT_LINE = "Il nostro cliente sei tu, non l’impresa.";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Controlla preventivo", to: "/controlla-preventivo" },
  { label: "Come funziona", to: "/come-funziona" },
  { label: "Esempio report", to: "/esempio-report" },
  { label: "Prezzi", to: "/prezzi" },
  { label: "Chi siamo", to: "/chi-siamo" },
  { label: "FAQ", to: "/#faq" },
];

export const FOOTER_GROUPS = [
  {
    title: "Prodotto",
    links: [
      { label: "Controlla preventivo", to: "/controlla-preventivo" },
      { label: "Come funziona", to: "/come-funziona" },
      { label: "Prezzi", to: "/prezzi" },
      { label: "Esempio report", to: "/esempio-report" },
    ],
  },
  {
    title: "Risorse",
    links: [
      { label: "FAQ", to: "/#faq" },
      { label: "Metodologia", to: "/metodologia" },
      { label: "Preventivi", to: "/preventivi" },
    ],
  },
  {
    title: "Azienda",
    links: [
      { label: "Chi siamo", to: "/chi-siamo" },
      { label: "Contatti", to: "/contatti" },
    ],
  },
  {
    title: "Legale",
    links: [
      { label: "Privacy Policy", to: "/privacy-policy" },
      { label: "Cookie Policy", to: "/cookie-policy" },
      { label: "Termini", to: "/termini" },
      { label: "Disclaimer", to: "/disclaimer" },
    ],
  },
];

// SEO cluster hub — architecture ready, individual pages NOT yet published/indexed.
export const CLUSTER_TOPICS = [
  { slug: "ristrutturazione-casa", label: "Ristrutturazione casa" },
  { slug: "ristrutturazione-bagno", label: "Ristrutturazione bagno" },
  { slug: "ristrutturazione-cucina", label: "Ristrutturazione cucina" },
  { slug: "impianto-elettrico", label: "Impianto elettrico" },
  { slug: "impianto-idraulico", label: "Impianto idraulico" },
  { slug: "pavimenti", label: "Pavimenti" },
  { slug: "tinteggiatura", label: "Tinteggiatura" },
  { slug: "infissi", label: "Infissi e serramenti" },
  { slug: "fotovoltaico", label: "Fotovoltaico" },
];

export const FAQS = [
  {
    q: "Come capire se un preventivo di ristrutturazione è troppo alto?",
    a: "Non esiste un singolo prezzo “giusto”: dipende da lavorazioni, materiali, zona e stato dell’immobile. Un preventivo va valutato voce per voce, confrontando ogni lavorazione con i riferimenti di mercato disponibili e verificando che quantità, unità di misura e materiali siano specificati. OKKIO segnala le voci che risultano superiori rispetto ai riferimenti disponibili, senza affermare che un prezzo sia “sbagliato”.",
  },
  {
    q: "Come confrontare due preventivi?",
    a: "Il confronto è affidabile solo se i due preventivi descrivono le stesse lavorazioni con lo stesso livello di dettaglio. Verifica che entrambi indichino quantità, unità di misura, materiali e cosa è incluso o escluso. Preventivi “a corpo” con voci generiche non sono direttamente confrontabili con preventivi analitici.",
  },
  {
    q: "Cosa deve contenere un preventivo edile?",
    a: "Un preventivo chiaro dovrebbe indicare: descrizione delle lavorazioni, quantità e unità di misura, prezzi unitari e totali, materiali previsti (con marca/modello quando rilevante), tempistiche, condizioni di pagamento, cosa è incluso ed escluso, e il trattamento dell’IVA. L’assenza di questi elementi non è di per sé un problema, ma rende necessario chiedere chiarimenti prima di firmare.",
  },
  {
    q: "Quali costi possono non essere inclusi?",
    a: "Voci frequentemente non incluse sono: smaltimento e trasporto delle macerie, ponteggi, ripristini murari e tinteggiature dopo gli impianti, materiali accessori, pratiche e permessi, allacci, e talvolta l’IVA. Non significa che manchino sempre: OKKIO segnala dove verificare se un costo è già compreso.",
  },
  {
    q: "Lo smaltimento delle macerie è normalmente specificato?",
    a: "Non sempre. Lo smaltimento e il trasporto a discarica autorizzata possono essere inclusi in una voce generica, indicati a parte, oppure esclusi. È uno degli aspetti da chiarire esplicitamente, perché può incidere in modo non trascurabile sul costo finale.",
  },
  {
    q: "Come viene considerata l’IVA?",
    a: "L’IVA sulle ristrutturazioni può variare in base al tipo di intervento e ai requisiti previsti dalla normativa. Un preventivo dovrebbe indicare chiaramente se gli importi sono IVA inclusa o esclusa e quale aliquota viene applicata. OKKIO segnala quando l’indicazione dell’IVA è assente o non chiara; per la tua situazione specifica fai riferimento a un professionista abilitato.",
  },
  {
    q: "Quanto costa ristrutturare casa al metro quadro?",
    a: "Il costo al metro quadro varia sensibilmente in base a zona, tipo di intervento, qualità dei materiali e stato di partenza dell’immobile. OKKIO non pubblica un prezzo al metro quadro “ufficiale” finché non dispone di un campione di dati reali sufficientemente ampio: preferiamo indicare “dati insufficienti” piuttosto che fornire un numero non verificabile.",
  },
  {
    q: "OKKIO sostituisce un geometra o un tecnico?",
    a: "No. OKKIO fornisce una seconda opinione indipendente a scopo informativo per aiutarti a fare le domande giuste prima di firmare. Non sostituisce il sopralluogo, la perizia o la consulenza di un geometra, architetto, ingegnere o altro professionista abilitato.",
  },
  {
    q: "Come vengono confrontati i prezzi?",
    a: "Ogni voce viene ricondotta a una lavorazione tipica e confrontata con i riferimenti di mercato disponibili per l’area indicata, quando presenti. Distinguiamo sempre tra ciò che è scritto nel documento (fatto), ciò che deduciamo (inferenza) e ciò che deriva da un confronto con riferimenti esterni (benchmark).",
  },
  {
    q: "Cosa succede se non ci sono dati sufficienti?",
    a: "Quando non esiste un riferimento affidabile per una voce, non inventiamo un prezzo: la voce viene classificata come “dati insufficienti per una valutazione affidabile”. Preferiamo dichiarare un limite piuttosto che fornire una stima non verificabile.",
  },
  {
    q: "OKKIO lavora per imprese edili?",
    a: "No. OKKIO è una piattaforma indipendente di analisi dei preventivi. Non è un’impresa edile, non vende ristrutturazioni e non riceve compensi dalle imprese analizzate. Il nostro cliente sei tu, non l’impresa.",
  },
  {
    q: "OKKIO guadagna consigliando determinate imprese?",
    a: "No. Non indirizziamo lavori verso imprese partner e non modifichiamo l’esito dell’analisi per favorire nessuno. Il ricavo di OKKIO deriva esclusivamente dal report che acquisti tu.",
  },
  {
    q: "Cosa succede ai documenti caricati?",
    a: "I documenti vengono utilizzati per produrre la tua analisi e generare il report. Il preventivo viene trasformato in dati strutturati (voci, quantità, prezzi) necessari all’analisi. Puoi consultare l’informativa Privacy per i dettagli su conservazione e trattamento.",
  },
  {
    q: "I miei dati vengono utilizzati per migliorare i benchmark?",
    a: "L’architettura di OKKIO è pensata per costruire nel tempo benchmark di prezzo per area geografica a partire dai dati strutturati dei preventivi analizzati. Eventuali utilizzi per il miglioramento dei riferimenti avvengono in forma aggregata e nel rispetto dell’informativa Privacy.",
  },
];

// Realistic demonstrative report (clearly labelled as demo in the UI).
export const DEMO_REPORT = {
  demo: true,
  paid: true,
  importo_totale: 24800,
  valuta: "EUR",
  num_voci: 9,
  livello_rischio: "medio",
  punteggio: 61,
  comune: "Bologna",
  tipologia: "Ristrutturazione bagno + cucina",
  sintesi:
    "Il preventivo è complessivamente strutturato ma presenta alcuni punti da chiarire prima della firma. Diverse voci sono indicate “a corpo” senza dettaglio di quantità, e non è specificato il trattamento dell’IVA. Alcune lavorazioni accessorie (ripristini e tinteggiature dopo gli impianti) non risultano esplicitamente incluse. Un paio di voci risultano nella fascia alta rispetto ai riferimenti disponibili per l’area, ma la mancanza di dettaglio rende difficile una valutazione precisa: si consiglia di richiedere un’integrazione scritta.",
  sections: {
    analisi_prezzi: {
      coerenti: [
        "Fornitura e posa piastrelle gres 60x60 a 52 €/mq — in linea con i riferimenti di mercato disponibili",
        "Tinteggiatura pareti a 11 €/mq — coerente con la fascia media",
        "Rifacimento impianto idraulico bagno (2.600 €) — nella media per l’area, da verificare i materiali inclusi",
      ],
      fascia_alta: [
        "Demolizioni e rimozioni a corpo (4.200 €) — risulta nella fascia alta rispetto ai riferimenti regionali; la mancanza di quantità rende difficile una valutazione precisa",
        "Fornitura cucina su misura (voce cumulativa) — importo superiore ai riferimenti disponibili in assenza di specifiche su materiali e finiture",
      ],
      non_valutabili: [
        "Fornitura sanitari (1.500 € a corpo) — nessuna specifica di marca, modello o composizione: dati insufficienti per una valutazione affidabile",
      ],
    },
    completezza: {
      presenti: [
        "Demolizioni e rimozioni",
        "Impianto idraulico bagno",
        "Posa pavimenti e rivestimenti",
        "Tinteggiatura",
      ],
      possibili_mancanti: [
        "Ripristini murari dopo il passaggio degli impianti",
        "Adeguamento impianto elettrico del bagno (punti luce/prese)",
        "Impermeabilizzazione del piatto doccia",
      ],
      da_chiarire: [
        "Trattamento dell’IVA (inclusa/esclusa e aliquota applicata)",
        "Smaltimento e trasporto delle macerie a discarica autorizzata",
        "Tempistiche e penali per eventuali ritardi",
      ],
    },
    extracosti: [
      { voce: "Smaltimento macerie", descrizione: "Non risulta indicato esplicitamente: verifica se è già compreso nelle demolizioni." },
      { voce: "Ponteggi / trabattelli", descrizione: "Non menzionati: potrebbero essere necessari per alcune lavorazioni in quota." },
      { voce: "Ripristini e tinteggiature post-impianti", descrizione: "Verifica se rientrano nella voce tinteggiatura o sono a parte." },
      { voce: "IVA", descrizione: "Non specificata: l’importo finale potrebbe variare in base all’aliquota applicata." },
    ],
    ambiguita: [
      { voce: "Demolizioni a corpo", problema: "Manca l’indicazione delle quantità (mq/mc): difficile confrontare il prezzo." },
      { voce: "Fornitura sanitari", problema: "Assenti marca, modello e composizione del set." },
      { voce: "Cucina su misura", problema: "Materiali, finiture ed elettrodomestici non dettagliati." },
    ],
    domande_impresa: [
      "Gli importi indicati sono IVA inclusa o esclusa? Quale aliquota viene applicata?",
      "Lo smaltimento e il trasporto delle macerie sono compresi nel prezzo?",
      "Le demolizioni a corpo a quali quantità (mq/mc) fanno riferimento?",
      "Per i sanitari, quali marca, modello e composizione sono previsti?",
      "I ripristini murari e le tinteggiature dopo gli impianti sono inclusi?",
      "È previsto l’adeguamento dell’impianto elettrico del bagno?",
      "Quali sono le tempistiche e cosa succede in caso di ritardo?",
    ],
    messaggio_pronto:
      "Buongiorno,\n\ngrazie per il preventivo inviato. Prima di procedere vorrei chiarire alcuni punti:\n\n1. Gli importi sono IVA inclusa o esclusa? Con quale aliquota?\n2. Lo smaltimento e il trasporto delle macerie sono compresi?\n3. Le voci indicate “a corpo” (demolizioni, cucina) a quali quantità e materiali fanno riferimento?\n4. Per i sanitari, potete indicarmi marca, modello e composizione?\n5. I ripristini murari e le tinteggiature dopo gli impianti sono inclusi?\n\nResto in attesa di un’integrazione scritta del preventivo. Grazie mille.\nCordiali saluti",
  },
  criticita: [
    {
      titolo: "IVA non specificata: importo finale incerto",
      categoria: "Trasparenza contrattuale",
      tipo: "ambiguita",
      natura: "fatto",
      gravita: "alta",
      descrizione:
        "Il preventivo non indica se gli importi sono IVA inclusa o esclusa né l’aliquota applicata. L’importo finale effettivo potrebbe differire da quello indicato: è opportuno chiarire questo punto per iscritto prima della firma.",
    },
    {
      titolo: "Demolizioni “a corpo” senza quantità",
      categoria: "Analisi prezzi",
      tipo: "voce_poco_chiara",
      natura: "inferenza",
      gravita: "media",
      descrizione:
        "La voce demolizioni è indicata a corpo per 4.200 € senza quantità (mq/mc). L’importo risulta nella fascia alta rispetto ai riferimenti disponibili, ma la mancanza di dettaglio non consente una valutazione affidabile: conviene chiedere il dettaglio delle quantità.",
    },
    {
      titolo: "Sanitari senza specifiche",
      categoria: "Ambiguità",
      tipo: "ambiguita",
      natura: "fatto",
      gravita: "media",
      descrizione:
        "La fornitura sanitari (1.500 € a corpo) non riporta marca, modello o composizione del set. Senza queste informazioni non è possibile valutare il valore incluso: dati insufficienti per una valutazione affidabile.",
    },
    {
      titolo: "Smaltimento macerie: verificare se incluso",
      categoria: "Extracosti",
      tipo: "extracosto",
      natura: "benchmark",
      gravita: "media",
      descrizione:
        "Lo smaltimento e il trasporto delle macerie non risultano indicati esplicitamente. Si tratta di una voce che, quando non compresa, può incidere sul costo finale: verifica se è già inclusa nelle demolizioni.",
    },
    {
      titolo: "Ripristini post-impianti non esplicitati",
      categoria: "Completezza",
      tipo: "lavorazione_mancante",
      natura: "inferenza",
      gravita: "bassa",
      descrizione:
        "Dopo il passaggio degli impianti sono spesso necessari ripristini murari e tinteggiature. Non risultano esplicitamente inclusi: verifica se rientrano nelle voci esistenti o sono da conteggiare a parte.",
    },
  ],
};
